var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrown1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.883 511.883",
    height: 512,
    viewBox: "0 0 511.883 511.883",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m384.906 193.554 7.559 15.117c10.759 21.546.39 48.153-27.466 55.898-.352.117-38.936 10.474-50.654-24.624l-11.294-33.926 32.139-32.153-79.307-118.945-79.307 118.945 32.139 32.153-11.294 33.926c-12.925 38.725-66.118 29.608-78.662 2.3-4.951-10.752-4.746-22.983.542-33.574l7.544-15.103-126.845-45.278 60.883 233.672 30 30h165 165l30-30 61-233.657z",
    fill: "#fed843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.883 381.962 61-233.657-126.977 45.249 7.559 15.117c10.759 21.546.39 48.153-27.466 55.898-.352.117-38.936 10.474-50.654-24.624l-11.294-33.926 32.139-32.153-79.307-118.945v357.041h165z",
    fill: "#fabe2c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.883 381.962h-195v75h195 195v-75z",
    fill: "#fabe2c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.883 381.962h195v75h-195z",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.85 328.929h106.066v106.066h-106.066z",
    fill: "#fabe2c",
    transform: "matrix(.707 -.707 .707 .707 -195.142 292.811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.883 306.962v150l75-75z",
    fill: "#ff9100"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown1);
export default __webpack_public_path__ + "static/media/crown1.793c3fb95b3a8c594cf883a93ffce1d2.svg";
export { ForwardRef as ReactComponent };